<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-row">
        <strong class="footer-brand">{{ brandUpper }}</strong>
        <span class="row-dot" aria-hidden="true">·</span>
        <nav class="footer-links" aria-label="Footer links">
          <router-link :to="{ name: 'en-about' }">About Us</router-link>
          <span class="link-sep" aria-hidden="true">|</span>
          <router-link :to="{ name: 'en-contact' }">Contact Us</router-link>
          <span class="link-sep" aria-hidden="true">|</span>
          <router-link :to="{ name: 'en-privacy' }">Privacy Policy</router-link>
          <span class="link-sep" aria-hidden="true">|</span>
          <router-link :to="{ name: 'en-terms' }">Terms of Use</router-link>
          <span class="link-sep" aria-hidden="true">|</span>
          <router-link :to="{ name: 'en-disclaimer' }">Disclaimer</router-link>
        </nav>
      </div>
      <p class="footer-desc">
        Independent GB WhatsApp resource with APK information, update notes,
        and simple installation guides.
      </p>
    </div>
    <div class="footer-bottom">
      <p>
        (c) 2026 {{ domain }}. This website is not affiliated with WhatsApp, Meta,
        or the GB WhatsApp development team.
      </p>
    </div>
  </footer>
</template>

<script>
import { SITE_BRAND_UPPER, SITE_DOMAIN } from '@/config/site'

export default {
  name: 'Footer',
  data() {
    return {
      brandUpper: SITE_BRAND_UPPER,
      domain: SITE_DOMAIN,
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  background: #ffffff;
  color: #111111;
  font-family: 'Lora', Georgia, serif;
  font-size: 16px;
  line-height: 1.625;
  padding: 28px 0 16px;
  border-top: 1px solid #e5ece8;
}

.footer-container {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}

.footer-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px 12px;
}

.footer-brand {
  color: #16a34a;
  font-family: 'Oswald', Arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.row-dot {
  color: #9ab5a6;
  font-size: 16px;
  line-height: 1;
}

.footer-links {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 10px;

  a {
    color: #222222;
    text-decoration: none;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
  }

  a:hover {
    color: #16a34a;
  }
}

.link-sep {
  color: #b7c9bf;
  font-size: 12px;
  line-height: 1;
}

.footer-desc {
  margin: 0;
  max-width: none;
  white-space: nowrap;
  color: #444444;
  font-size: 14px;
  line-height: 1.55;
}

.footer-bottom {
  width: min(1120px, calc(100% - 32px));
  margin: 18px auto 0;
  padding-top: 14px;
  border-top: 1px solid #e5ece8;

  p {
    margin: 0;
    text-align: center;
    font-size: 12px;
    color: #6b7f74;
  }
}

@media (max-width: 760px) {
  .footer {
    padding-bottom: 20px;
  }

  .footer-row {
    gap: 8px;
  }

  .footer-desc {
    white-space: normal;
    font-size: 13px;
  }
}
</style>
